import { render, staticRenderFns } from "./AuthFormModal.vue?vue&type=template&id=b09d4e38&scoped=true"
import script from "./AuthFormModal.vue?vue&type=script&lang=js"
export * from "./AuthFormModal.vue?vue&type=script&lang=js"
import style0 from "./AuthFormModal.vue?vue&type=style&index=0&id=b09d4e38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09d4e38",
  null
  
)

export default component.exports